export function createPressEvent(event, currentTarget, source) {
    return {
        source: source,
        target: event.target,
        currentTarget: currentTarget,
        shiftKey: event.shiftKey,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
    };
}
